import { inject } from '@angular/core';
import {
  IsActiveMatchOptions,
  Router,
  ViewTransitionInfo,
  ViewTransitionsFeatureOptions,
} from '@angular/router';

export const viewTransitionOptions: ViewTransitionsFeatureOptions = {
  onViewTransitionCreated: ({ transition }: ViewTransitionInfo) => {
    const router = inject(Router);
    const targetUrl = router.currentNavigation()?.finalUrl;

    const config: IsActiveMatchOptions = {
      paths: 'exact',
      matrixParams: 'exact',
      fragment: 'ignored',
      queryParams: 'exact',
    };

    if (targetUrl && router.isActive(targetUrl, config)) {
      transition.skipTransition();
    }
  },
};
